// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._16jlkb7n{flex-grow:1}
._19pk1b66{margin-top:var(--ds-space-050,4px)}
._1bsb1osq{width:100%}
._1e0c1txw{display:flex}
._1tket9kd{min-height:72px}
._4cvr1q9y{align-items:baseline}
._4cvr1y6m{align-items:flex-start}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/link-datasource/dist/esm/ui/jira-issues-modal/jira-search-container/index.compiled.css"],"names":[],"mappings":"AAAA,WAAW,WAAW;AACtB,WAAW,kCAAkC;AAC7C,WAAW,UAAU;AACrB,WAAW,YAAY;AACvB,WAAW,eAAe;AAC1B,WAAW,oBAAoB;AAC/B,WAAW,sBAAsB","sourcesContent":["._16jlkb7n{flex-grow:1}\n._19pk1b66{margin-top:var(--ds-space-050,4px)}\n._1bsb1osq{width:100%}\n._1e0c1txw{display:flex}\n._1tket9kd{min-height:72px}\n._4cvr1q9y{align-items:baseline}\n._4cvr1y6m{align-items:flex-start}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
